import log from 'chameleon/ui-stack/utilities/log';
import getSectionsByType from './getSectionsByType';
import getFormAndDisabledStudentsById from './getFormAndDisabledStudentsById';
import {
  getResourceAssigneesStudents,
  getSharedResourceToClassStudents,
} from 'chameleon-src/queries';
import { calculateClassesStats } from 'chameleon-src/components/assign/AssignManageForm/utils';

const loadInitialData = (props, handlers) => {
  const {
    globals,
    isAssign,
    item,
    items,
    userClasses,
    subject: { id: subjectId, classes: subjectClasses },
    selectedAssignment: { id: selectedAssignmentId } = {},
    client,
    userData: { chosenEducationPeriodCode },
  } = props;
  const intChosenEducationPeriodCode = Number.parseInt(
    chosenEducationPeriodCode,
    10,
  );
  const {
    isLoading: isGlobalLoading,
    state,
    setState,
    setDisabledStudents,
    classesStats,
    dispatchClassesStats,
  } = globals;
  const { setIsLoading } = handlers;
  const classIds = (userClasses || subjectClasses || []).map((s) =>
    Number.parseInt(s.id, 10),
  );
  let subjectUsedClasses;
  if (!!userClasses) {
    subjectUsedClasses = (subjectClasses || []).filter((c) =>
      classIds.includes(Number.parseInt(c.id, 10)),
    );
  } else {
    subjectUsedClasses = (subjectClasses || []).filter(
      (s) => s.educationPeriod === intChosenEducationPeriodCode,
    );
  }

  (async () => {
    if (isAssign) {
      let assignees;

      if ((items || []).length > 1) {
        assignees = [];
      } else {
        const { resourceId } = item || items[0];

        try {
          const response = await client.query({
            fetchPolicy: 'network-only',
            query: getResourceAssigneesStudents,
            variables: {
              resourceId,
              subjectId: Number.parseInt(subjectId, 10),
              classIds,
            },
          });

          ({ assignees } = response.data.resourceAssigneesStudents);
        } catch (error) {
          log(error);
        }
      }

      getSectionsByType(subjectUsedClasses, assignees, (r) => {
        setState({
          ...state,
          regularSections: r.regularSections,
          progressSections: r.progressSections,
        });
        dispatchClassesStats(
          calculateClassesStats({
            stats: classesStats,
            classList: subjectClasses,
            disabledStudents: r.disabledStudents,
          }),
        );
        setDisabledStudents(r.disabledStudents);
        setIsLoading(false);
      });
    } else {
      let sharedResourceToClassIds;
      // Initially load data for all assignments.
      // We need this to display the number of students selected.
      if (isGlobalLoading) {
        sharedResourceToClassIds = item.assignments.map((a) => a.id);
      } else {
        sharedResourceToClassIds = [Number.parseInt(selectedAssignmentId, 10)];
      }

      const response = await client.query({
        fetchPolicy: 'network-only',
        query: getSharedResourceToClassStudents,
        variables: {
          sharedResourceToClassIds,
        },
      });

      const {
        sharedResourceToClassStudents: { assignments },
      } = response.data;

      getFormAndDisabledStudentsById(
        {
          subjectClasses,
          assignments,
        },
        (disabledStudents) => {
          setDisabledStudents(disabledStudents);
          dispatchClassesStats(
            calculateClassesStats({
              stats: classesStats,
              classList: subjectClasses,
              disabledStudents,
            }),
          );
          setIsLoading(false);
        },
      );
    }

    setIsLoading(false);
  })();
};

export default loadInitialData;
